import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import * as Common from "../CommonControlls/CommonJs";
import DropDown from "../CommonControlls/DropdownRendrer";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import BarsGraph from "../Graphs/BarsGraph";
import LineChart from "../Graphs/LineChart";
import PieCharts from "../Graphs/PieCharts";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import { SelectPageLastSearch } from "../OfflineDb/IndexDbTranscSP";
class Dashboard2 extends Component {
	constructor(props) {
		super(props);
		
	}

	componentWillMount() {
		//if (this.props.UserAuthentication.AuthToken === "") {
		//	this.props.history.push("/Login");
		//}
	}

	componentDidMount() {
		//this.props.ShowLoader({ Isloading: false });
	}
	
	render() {
		return (
			<div>
				<MainLayout />
				<div id="right-panel" className="right-panel">
					<Topmenu
						PageTitle="Dashboard"
						showHideFilters={this.ShowHideFilters}
						isShowAddBtn={false}
						isShowPrintBtn={true}
						AddBtnLabel=""
						AddBtnLink=""
					/>
					
				</div>
			</div>
		);
	}
}

export default connect()(Dashboard2);
